import script from "./BaseForm.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseForm.vue?vue&type=script&setup=true&lang=js"

import "./BaseForm.vue?vue&type=style&index=0&id=dda21670&lang=scss"

const __exports__ = script;

export default __exports__